import ApiService from "./api.service";

class CommunicationService extends ApiService {
    searchSms(data) {
        return this.post(`api/management/sms/search`, data);
    }
    getSmsStatistics() {
        return this.get(`api/management/sms/statistics`);
    }
    getSmsCredits() {
        return this.get(`api/management/sms/credits`);
    }
    exportSms(data){
        return this.post(`api/management/sms/export`, data, { responseType: "arraybuffer" });
    }
    searchEmails(data) {
        return this.post(`api/management/email/search`, data);
    }
    getEmailStatistics() {
        return this.get(`api/management/email/statistics`);
    }
    exportEmails(data){
        return this.post(`api/management/email/export`, data, { responseType: "arraybuffer" });
    }
    addAnnoucementForUsers(data) {
        return this.post(`api/management/announcement`, data)
    }
    getAnnoucementBetweenDates(date_from, date_to) {
        return this.post("api/management/announcement/between", { date_from, date_to });
    }
    searchAnnoucements(data) {
        return this.post(`api/management/announcement/search`, data)
    }
    deleteAnnouncement(id) {
        return this.delete(`api/management/announcement/${id}`)
    }
    updateAnnoucementForUsers(data) {
        return this.post(`api/management/announcement/${data.id}`, data)
    }
    showLogs(id) {
        return this.get(`api/management/announcement/${id}/logs`)
    }
    getGroups() {
        return this.get('Message/getGroupsForFilter')
    }
    getSpecyficAnnoucement(id) {
        return this.get(`api/management/announcement/${id}`)
    }
    reorderAnnoucementAttachemnt(id, data) {
        return this.post(`api/management/announcement/${id}/attachements/reorder`, data);
    }
    exportAnnouncementLogs(id) {
        return this.get(`api/management/announcement/${id}/export-logs`, { responseType: "arraybuffer" });
    }
}

export default new CommunicationService();